<template>
  <div class="ChallengeHome">
    <div class="top">
      <div class="action" @click="onCreate">
        <p>Create Challenge</p>
        <i class="el-icon-circle-plus"></i>
      </div>
    </div>
    <div class="bottom">
      <h2>All Challenges</h2>
      <el-table
          v-if="challenge_list.length!==0"
          class="table"
          height="500"
          :row-style="tableRowClassName"
          :data="challenge_list">
        <el-table-column label="State" width="100">
          <template slot-scope="scope">
            <i :class="scope.row.challenge_active==='Active'?'el-icon-video-play':'el-icon-switch-button'"></i>
            <span style="margin-left: 10px">{{ scope.row.challenge_active }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Title" width="280" prop="challenge_title_en"></el-table-column>
        <el-table-column label="Prize" width="60" prop="challenge_prize_enable_text"></el-table-column>
        <el-table-column label="Top" width="60" prop="challenge_top_state"></el-table-column>
        <el-table-column label="Start Date" width="120" prop="challenge_start"></el-table-column>
        <el-table-column label="End Date" width="120" prop="challenge_end"></el-table-column>
        <el-table-column label="Steps" width="100" prop="challenge_step_count"></el-table-column>
        <el-table-column label="Joined" width="100" prop="part_num"></el-table-column>
        <el-table-column label="Complete" width="100" prop="com_num"></el-table-column>
        <el-table-column label="Pub Date" width="110" prop="publish_date"></el-table-column>
        <el-table-column width="160">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="onEdit(scope.$index, scope.row)">Edit
            </el-button>
            <el-button
                size="mini"
                type="danger"
                @click="onDelete(scope.$index, scope.row)">Delete
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {getChallengeList, deleteChallenge} from '@/utils/api'

  export default {
    props: {},
    data: () => {
      return {
        challenge_list: []
      }
    },
    beforeCreate() {
      this.$showLoading('Loading');
      getChallengeList().then(res => {
        this.challenge_list = res.challenge_list;
        this.$hideLoading()
      })
    },
    methods: {
      onCreate(){
        this.$emit('switch', {
          target: 'create',
        })
      },
      onEdit(index, row) {
        this.$emit('switch', {
          target: 'detail',
          id: row.challenge_id
        })
      },
      onDelete(index, row) {
        this.$confirm(`Are you sure you want to delete this challenge? All related user records will be cleared.`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteChallenge(row.challenge_id).then(res => {
            if (res.errcode === 0) {
              this.challenge_list.splice(index, 1);
              this.$message({
                type: 'success',
                message: `Challenge Deleted!`
              });
            }
          });
        }).catch(() => {
        });
      },
      tableRowClassName({row}) {
        if (row.challenge_active === 'Ended') {
          return 'background: #ebebeb';
        }
        return '';
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_ChallengeHome.scss";
</style>